import {LocaleDictionaryRegistrationPage} from "../../interface/registrationPage";
import {PersonalAgreement} from "./personalAgreement";

export const registrationPage: LocaleDictionaryRegistrationPage = {
    checkBoxCaption1: 'Я даю свое',
    checkBoxCaptionLink: 'согласие на обработку персональных данных',
    checkBoxCaption2: 'Я присоединяюсь к',
    checkBoxCaptionLink2: 'электронному взаимодействию',
    checkBoxCaption3: 'Я ознакомлен(а)',
    checkBoxCaptionLink3: 'с политикой обработки персональных данных',
    agreementTitle: 'Согласие на обработку персональных данных и соглашение об электронном взаимодействии',
    agreementTitle2: 'Политика конфиденциальности',
    agreementText: PersonalAgreement,
    personalDataProcessingLink: 'https://privacypolicy.rudn.ru/consent_to_the_processing_of_personal_data.html',
    electronicInteractionAgreement: 'https://privacypolicy.rudn.ru/agreement_between_participants_in_electronic_interaction.htm',
    personalDataPolicyLink: 'https://privacypolicy.rudn.ru/personal_data_processing_policy.pdf',
}
